import axios from 'axios'
import { debounce } from 'lodash'
import rebuildSelect from ':/functions/rebuild-select'

export default () => ({
  shippingAccount: {
    vendor: '',
    method: '',
    number: '',
    is_default: false,
  },
  vendors: {},
  methods: {},
  errors : [],
  canSubmit: false,
  submitting: false,
  init() {

    this.$watch('shippingAccount.vendor', debounce((to, from) => {
      if(to !== from) {
        this.updateMethods()
      }
    }, 100))

  },
  open(event, account = null) {

    const params = {}

    if(account) {
      params.account = account
    }

    axios.get(`/account/shipping-accounts/ajax/${account ? 'edit' : 'add'}`, {
      params: params
    }).then(response => {
      this.$dispatch('modal-open', {
        content: response.data.template
      })
    })

  },
  submit(event) {

    if(!this.canSubmit) {
      event.preventDefault();
    }

    this.submitting = true;

    this.validate();

    if(this.errors.length) {
      this.submitting = false;
      return
    }

    this.canSubmit = true;
    this.$refs['form'].submit();
  },
  validate() {

    this.errors = [];

    if(this.shippingAccount.vendor == '') {
      this.errors.push('Vendor is required.')
    }

    if(this.shippingAccount.method == '') {
      this.errors.push('Method is required.')
    }
  },
  updateMethods() {

    const select = this.$refs['method'];

    axios.get('/account/shipping-accounts/ajax/methods-for-vendor', {
      params: {
        vendor: this.shippingAccount.vendor
      }
    })
    .then(response => {

      if(response.data.success === false || response.data.methods.length === 0) {
        this.methods = {}
        this.shippingAccount.method = '';
        return
      }

      this.methods = response.data.methods

      const value = this.methods.hasOwnProperty(this.shippingAccount.method) ?
        this.shippingAccount.method :
        this.methods[Object.keys(this.methods)[0]]

      rebuildSelect(select, this.methods, null, value)

      this.shippingAccount.method = value;

    })
  },
})
